import { Component, OnInit, inject, signal } from "@angular/core";
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { MessageService, ConfirmationService, SelectItem, PrimeTemplate } from 'primeng/api';
import { Observable, of } from 'rxjs';
import { LEVEL_PUBLISHED, PARAM_PAGES_PATH, STATE_LIST, STATE_PAGES_PUBLISHED, TEMPLATE_PUBLISHED } from 'src/app/constants/constants';
import { AbstractFormComponent } from '../../common/abstract-edit.component';
import { Pages } from 'src/app/models/pages';
import { PagesService } from 'src/app/services/pages.service';
import { TopNavComponent } from '../../top-nav/top-nav.component';
import { Bind } from 'primeng/bind';
import { ButtonDirective } from 'primeng/button';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from 'primeng/tabs';

import { Ripple } from 'primeng/ripple';
import { Card } from 'primeng/card';
import { InputText } from 'primeng/inputtext';
import { Editor } from 'primeng/editor';
import { SelectButton } from 'primeng/selectbutton';
import { Select } from 'primeng/select';
import { UploadComponent } from '../../components/upload/upload.component';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Toast } from 'primeng/toast';

import { TPipe } from "../../i18n/t.pipe";
@Component({
    standalone: true,
    selector: "app-pages-form",
    templateUrl: "./pages-form.component.html",
    imports: [TPipe, TopNavComponent, FormsModule, ReactiveFormsModule, Bind, ButtonDirective, RouterLink, Tabs, TabList, Ripple, Tab, TabPanels, TabPanel, Card, InputText, Editor, PrimeTemplate, SelectButton, Select, UploadComponent, ConfirmDialog, Toast]
})

export class PagesFormComponent extends AbstractFormComponent<Pages> implements OnInit {
  protected fb: FormBuilder;
  private pagesService = inject(PagesService);

  pageTitle: string;
  form: FormGroup;
  idField = 'id';
  formFields = [
    'id',
    'title',
    'slug',
    'page_seotitle',
    'page_seodescription',
    'description_1',
    'description_2',
    'description_3',
    'mother_page_id',
    'status',
    'page_template',
    'is_active'
  ];

  item$: Observable<Pages> = of();
  readonly stateOptions = signal(STATE_LIST);
  service = this.pagesService;
  readonly element = signal<Pages>(undefined);
  readonly selectedStatePublished = signal<SelectItem[]>([]);
  selectedTemplatePublished: SelectItem[] = [];
  selectedLevelPublished: SelectItem[] = [];
  statePublished = STATE_PAGES_PUBLISHED;
  readonly levelPublished = signal<any[]>(undefined);
  selectedPagesPublished: Pages[];
  readonly pages = signal<Pages[]>([]);
  readonly templatePublished = signal<any[]>(undefined);

  constructor() {
    const fb = inject(FormBuilder);
    const messageService = inject(MessageService);
    const confirmationService = inject(ConfirmationService);
    const router = inject(Router);
    const route = inject(ActivatedRoute);

    super(fb, messageService, confirmationService, router, route, PARAM_PAGES_PATH);
    this.fb = fb;

    this.stateOptions.set(STATE_LIST);
  }

  ngOnInit() {
    this.initializeForm();
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.pageTitle = 'Modifica Pagina';
      this.loadItem(id);
      this.loadPages();
    } else {
      this.pageTitle = 'Aggiungi Pagina';
    }

    this.templatePublished.set(TEMPLATE_PUBLISHED);
    this.levelPublished.set(LEVEL_PUBLISHED);
  }

  loadPages(): void {

    const params = {
      page: 0,
      size: 1000,
    };
    this.pagesService.list(params).subscribe((pData) => {
      this.pages.set(pData);
    });
  }

  initializeForm() {
    this.form = this.fb.group({
      id: [""],
      title: ["", Validators.required],
      page_template: [""],
      slug: [""],
      description_1: [""],
      description_2: [""],
      description_3: [""],
      page_seotitle: [""],
      mother_page_id: [""],
      page_seokeywords: [""],
      page_seodescription: [""],
      level: [""],
      status: [""],
      is_active: ["0"],
    });
  }

  loadItem(id: string) {
    this.service.getId(id).subscribe(
      res => {
        this.element.set(res)
        this.form.patchValue({
          title: res.title,
          page_template: res.page_template,
          slug: res.slug,
          description_1: res.description_1,
          description_2: res.description_2,
          description_3: res.description_3,
          page_seotitle: res.page_seotitle,
          page_seokeywords: res.page_seokeywords,
          mother_page_id: res.mother_page_id,
          page_seodescription: res.page_seodescription,
          status: res.status,
          is_active: res.is_active,
          id: res.id,
        });
      },
      error => this.error = error
    );
  }
}
